class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
    this.attachEvents();
  }

  init() {
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector(
      'predictive-search-results',
    );
    this.form = this.querySelector('form');
    this.clearBtn = this.querySelector('[data-clear]');
    this.onFocus = this.onFocus.bind(this);
  }

  attachEvents() {
    this.form?.addEventListener('submit', this.onFormSubmit.bind(this));
    this.input?.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );
    this.input?.addEventListener('focus', this.onFocus);
    this.input?.addEventListener('click', this.onFocus);

    document.addEventListener('click', this.clickOutside.bind(this));

    this.clearBtn?.addEventListener('click', this.close.bind(this, true));
  }

  clickOutside(event) {
    if (event.target !== this && !event.target.closest('predictive-search')) {
      this.close();
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  hasQuery() {
    return !!this.getQuery().length;
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!this.hasQuery()) {
      this.close(true);
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.hasQuery() || this.querySelector('[aria-selected="true"] a'))
      event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!this.hasQuery()) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm,
      )}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent(
        'resources[limit]',
      )}=5&${encodeURIComponent(
        'resources[options][fields]',
      )}=title,product_type,variants.title,vendor,tag&section_id=predictive-search`,
    )
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        this.cachedResults[queryKey] = resultsMarkup;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  populateSearchResults(html = '') {
    this.predictiveSearchResults.innerHTML = html;
  }

  renderSearchResults(resultsMarkup) {
    this.populateSearchResults(resultsMarkup);
    this.initSlider();
    this.initProductsRatingWidget();
    this.open();
  }

  initSlider() {
    const slider = this.predictiveSearchResults.querySelector('[data-slider]');

    if (!slider) {
      return;
    }

    const options = {
      slidesPerView: 'auto',
      spaceBetween: 20,
    };

    new Swiper(slider, options);
  }

  initProductsRatingWidget() {
    const widgets = this.predictiveSearchResults.querySelectorAll(
      '[data-oke-star-rating]',
    );

    widgets.forEach((widget) => {
      window.okeWidgetApi?.initWidget(widget);
    });
  }

  open() {
    this.predictiveSearchResults.classList.add('is-open');

    bodyScroll.lock(
      this.predictiveSearchResults.querySelector('[data-suggestions]'),
    );
  }

  close(clearSearchTerm = false) {
    if (!this.predictiveSearchResults.classList.contains('is-open')) {
      return;
    }

    if (clearSearchTerm) {
      this.input.value = '';
    }

    this.predictiveSearchResults.classList.remove('is-open');

    bodyScroll.clear();
  }
}

customElements.define('predictive-search', PredictiveSearch);
